import type { FullParcel, ParcelStatus } from '@coig/apm-api';
import { lockerManagmentService, packageManagementService } from './apiService';

export const packageManagmentServices = {
  async getSentPackages() {
    const packages = await packageManagementService.getParcelList();
    return packages.parcels?.filter((parcel: FullParcel) => parcel.status === 'SENT' || parcel.status === 'READY_TO_SEND' || parcel.status === 'TRANSPORT' || parcel.status === 'RECEIVED');
  },

  async getReceivedPackages() {
    const packages = await packageManagementService.getParcelList();
    return packages.parcels?.filter((parcel: FullParcel) => parcel.status === 'RECEIVED' || parcel.status === 'READY_TO_RECEIVE');
  },

  async updatePackage(id: FullParcel['id'], fullParcel: FullParcel) {
    const requestBody = { ...fullParcel };
    // delete requestBody.qrCode;
    // delete (requestBody as Partial<FullParcel>).registrationTime;
    // delete (requestBody as Partial<FullParcel>).statusModificationTime;
    // delete requestBody.compartmentId;
    // await packageManagementService.updateParcel({ id, requestBody });
    await packageManagementService.updateParcel({ id, requestBody });
  },

  async deleteParcels() {
    await packageManagementService.deleteParcels();
  },

  async openLocker(fullParcel: FullParcel) {
    let requestBody = {};
    if (fullParcel.compartmentId) {
      requestBody = { compartmentIds: [fullParcel.compartmentId] };
    }
    await lockerManagmentService.openParcelLocker({ requestBody });
    if (typeof (lockerManagmentService as any).mockService === 'function') {
      const parcelDeposited = true;
      let status: ParcelStatus = 'RECEIVED';
      if (fullParcel.status === 'READY_TO_SEND' || fullParcel.status === 'SENT') {
        status = 'SENT';
      }
      const packageParcel: FullParcel = { ...fullParcel, status, parcelDeposited };
      await this.updatePackage(fullParcel.id, packageParcel);
      return packageParcel;
    }
  },

  async getPackage(id: string) {
    const packages = await packageManagementService.getParcelList();
    return packages.parcels!.filter((parcel: FullParcel) => parcel.id === id)[0];
  },

};
